import { render, staticRenderFns } from "./NanHaiPensionDevelopmentProcess.vue?vue&type=template&id=aca1aa2e&"
import script from "./NanHaiPensionDevelopmentProcess.vue?vue&type=script&lang=js&"
export * from "./NanHaiPensionDevelopmentProcess.vue?vue&type=script&lang=js&"
import style0 from "./NanHaiPensionDevelopmentProcess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports